if (!customElements.get('product-quantity-bundle')) {
	customElements.define('product-quantity-bundle', class ProductQuantityBundle extends HTMLElement {
		connectedCallback() {
			this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
			this.radios.forEach((radio) => radio.addEventListener('change', this.onTierChange));
			document.addEventListener('variant:change', this.onVariantChange);
			try { sessionStorage.setItem('svytBundleTarget', '1'); } catch (error) {}
			this.updateSelection();
		}

		disconnectedCallback() {
			this.radios?.forEach((radio) => radio.removeEventListener('change', this.onTierChange));
			document.removeEventListener('variant:change', this.onVariantChange);
		}

		onTierChange = () => {
			this.updateSelection();
			const target = Number(this.querySelector('input:checked')?.value || 1);
			try { sessionStorage.setItem('svytBundleTarget', String(target)); } catch (error) {}
			const buttonLabel = this.closest('[id^="ProductInfo-"]')?.querySelector('.product-form__submit span');
			if (buttonLabel) {
				if (!buttonLabel.dataset.defaultLabel) buttonLabel.dataset.defaultLabel = buttonLabel.textContent;
				const translatedLabel = target === 2 ? this.dataset.ctaOne : this.dataset.ctaTwo;
				buttonLabel.textContent = target > 1 ? translatedLabel : (buttonLabel.dataset.defaultLabel || buttonLabel.textContent);
			}
		};

		onVariantChange = (event) => {
			if (event.detail.sectionId !== this.dataset.sectionId || !event.detail.variant) return;
			this.dataset.unitPrice = event.detail.variant.price;
			this.updatePrices();
		};

		updateSelection() {
			this.querySelectorAll('.quantity-bundle__tier').forEach((tier) => {
				tier.classList.toggle('is-selected', Boolean(tier.querySelector('input:checked')));
			});
		}

		updatePrices() {
			const price = Number(this.dataset.unitPrice);
			[1, 2, 3].forEach((quantity) => {
				const discount = quantity === 2 ? Number(this.dataset.twoDiscount) : quantity >= 3 ? Number(this.dataset.threeDiscount) : 0;
				const unitPrice = Math.round(price * (100 - discount) / 100);
				const total = Math.round(price * quantity * (100 - discount) / 100);
				const priceNode = this.querySelector(`[data-tier-price="${quantity}"]`);
				const regularNode = this.querySelector(`[data-tier-regular="${quantity}"]`);
				const tierLabel = this.querySelector(`[data-tier-label="${quantity}"]`);
				const savingsLabel = this.querySelector(`[data-tier-savings="${quantity}"]`);
				if (priceNode) priceNode.textContent = formatMoney(total);
				if (regularNode) regularNode.textContent = formatMoney(price * quantity);
				if (tierLabel) tierLabel.textContent = tierLabel.dataset.labelTemplate.replace('__PRICE__', formatMoney(unitPrice));
				if (savingsLabel) savingsLabel.textContent = savingsLabel.dataset.labelTemplate.replace('__AMOUNT__', formatMoney(price * quantity - total));
			});
		}
	});
}
